// nanosec to millisec 1^e-6
export const NANOSECONDS_TO_MILLISECONDS = 1 / 1000000
export const INACTIVE_AGENT_HOURS = 24
export const HR_TO_MILLISECONDS = 3600000

// datetime format
export const DATETIME_FORMAT = 'MM/DD/YY hh:mm A'
export const DATETIME_FORMAT_MTH_DAY_YR = 'MM/DD/YY'
export const DATETIME_FORMAT_SHORT = 'MM/DD hh:mm A'
export const DATETIME_FORMAT_HR_MIN = 'HH:mm'
export const DATETIME_FORMAT_MONTH_DAY = 'MMM DD'
export const DATETIME_FORMAT_12HR = 'hh:mm A'
export const DATETIME_FORMAT_LONG = 'MMMM Do YYYY, h:mm a'
export const DATETIME_STATS_ARGS_FORMAT = 'YYYYMMDD'
export const DATETIME_STATS_DISPLAY_FORMAT = 'MM/DD'

export const DATE_RANGE_CHOICES = [
  { label: 'since midnight', value: 'SINCE_MIDNIGHT', hours: 24 },
  { label: 'past 1 hour', value: 'PAST_1_HOURS', hours: 1 },
  { label: 'past 2 hours', value: 'PAST_2_HOURS', hours: 2 },
  { label: 'past 4 hours', value: 'PAST_4_HOURS', hours: 4 },
  { label: 'past 24 hours', value: 'PAST_24_HOURS', hours: 24 },
  { label: 'past 48 hours', value: 'PAST_48_HOURS', hours: 48 },
  { label: 'past 72 hours', value: 'PAST_72_HOURS', hours: 72 },
  { label: 'past 1 week', value: 'PAST_1_WEEK', hours: 168 },
  { label: 'past 1 month', value: 'PAST_1_MONTH', hours: 720 }
]

export const INSIGHTS_DATE_RANGE_CHOICES = [
  { label: 'past 1 hour', value: 'PAST_1_HOURS', hours: 1 },
  { label: 'past 2 hours', value: 'PAST_2_HOURS', hours: 2 },
  { label: 'past 4 hours', value: 'PAST_4_HOURS', hours: 4 },
  { label: 'past 24 hours', value: 'PAST_24_HOURS', hours: 24 },
  { label: 'past 48 hours', value: 'PAST_48_HOURS', hours: 48 },
  { label: 'past 72 hours', value: 'PAST_72_HOURS', hours: 72 },
  { label: 'past 1 week', value: 'PAST_1_WEEK', hours: 168 },
  { label: 'past 1 month', value: 'PAST_1_MONTH', hours: 720 }
]



// WEBPACK FOOTER //
// ./src/constants/datetime.constants.js